import axios from "axios";

import { GOPEOPLE_API_URL } from "../config";
import { store } from "..";

let cachedJwt = null;
let jwtPromise = null;

const getTtpToken = () => {
  try {
    return store.getState()?.auth?.token || null;
  } catch (e) {
    return null;
  }
};

const fetchGoPeopleJwt = async () => {
  const ttpToken = getTtpToken();
  if (!ttpToken || !GOPEOPLE_API_URL) return null;

  try {
    const res = await fetch(
      `${GOPEOPLE_API_URL}/auth/autologin_token?access_token=${encodeURIComponent(
        ttpToken,
      )}`,
      { method: "GET", headers: { Accept: "application/json" } },
    );
    if (!res.ok) return null;
    const data = await res.json();
    return data?.token || null;
  } catch (e) {
    return null;
  }
};

const getGoPeopleJwt = async (forceRefresh = false) => {
  if (cachedJwt && !forceRefresh) return cachedJwt;
  if (forceRefresh) cachedJwt = null;

  if (!jwtPromise) {
    jwtPromise = fetchGoPeopleJwt().finally(() => {
      jwtPromise = null;
    });
  }
  cachedJwt = await jwtPromise;
  return cachedJwt;
};

const goPeopleAxios = axios.create({
  baseURL: GOPEOPLE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

goPeopleAxios.interceptors.request.use(
  async (config) => {
    const token = await getGoPeopleJwt();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// On a 401, the exchanged JWT is stale/invalid: refresh it once and retry.
goPeopleAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status !== 401 ||
      !originalRequest ||
      originalRequest._retry
    ) {
      return Promise.reject(error);
    }
    originalRequest._retry = true;
    const token = await getGoPeopleJwt(true);
    if (!token) return Promise.reject(error);
    originalRequest.headers.Authorization = `Bearer ${token}`;
    return goPeopleAxios(originalRequest);
  },
);

// Fetches an author's dedicated newsletter image from the GoPeople
export const getGoPeopleUserNewsletterImage = async (userId) => {
  if (!userId || !GOPEOPLE_API_URL) return null;

  try {
    const { data } = await goPeopleAxios.get(
      `/users/${userId}/complete-profile?fields[user]=newsletter_image_url`,
    );
    return (
      data?.user?.newsletter_image_url ?? data?.newsletter_image_url ?? null
    );
  } catch (e) {
    return null;
  }
};
